import React, { useEffect, useRef } from "react";
import { Filter } from "../../sections/home/components";
import ScrollProgressIndicator from "../../sections/home/components/MouseProgressTrack";
import { useProjectsList } from "../../../contexts/ProjectsListContext";

import { motion } from "framer-motion";
import { useVisibility } from "../../../utils/useVisibility";
import CLink from "../../_reusables/CLink";

const Header = () => {
	const { myElementIsVisible } = useProjectsList();

	const filterContainerRef = useRef(null);

	useEffect(() => {
		if (filterContainerRef !== null) {
			if (
				filterContainerRef.current.firstChild.classList.contains("show")
			) {
				filterContainerRef.current.classList.add("hide-overflow");

				setTimeout(() => {
					filterContainerRef.current.classList.remove(
						"hide-overflow"
					);
				}, 500);
			} else {
				filterContainerRef.current.classList.add("hide-overflow");
			}
		}
	}, [myElementIsVisible]);

	const { isVisible: showMobileNav, toggle } = useVisibility();

	const toggleMobileNav = () => {
		const html = document.documentElement;

		if (showMobileNav) {
			setTimeout(() => {
				html.classList.remove("hide-scrollbar");
			}, 500);
		} else {
			setTimeout(() => {
				html.classList.add("hide-scrollbar");
			}, 100);
		}

		toggle();
	};

	const { activeFilter } = useProjectsList();

	return (
		<header className="page-header">
			<div className="title-container">
				<div className="brand-title">
					<ScrollProgressIndicator />

					<h1>TheCopyDev</h1>
				</div>

				<motion.span
					className={`separator ${
						myElementIsVisible ? "show" : "hide"
					}`}
				></motion.span>

				<span
					className={`heading ${
						myElementIsVisible ? "show" : "hide"
					}`}
				>
					{/* {activeFilter.title} */}
					{/* Works */}
					Projects
				</span>
			</div>

			<div className={`header-filter-container`} ref={filterContainerRef}>
				<Filter className={`${myElementIsVisible ? "show" : "hide"}`} />
			</div>

			<div>
				<DesktopNav />

				<button
					className="mobile-menu hover-transition"
					onClick={toggleMobileNav}
				>
					MENU +
				</button>

				<MobileNav
					showMobileNav={showMobileNav}
					toggleMobileNav={toggleMobileNav}
				/>
			</div>
		</header>
	);
};

export default Header;

const navDetails = [
	{
		title: "Contact Me",
	},
];

const DesktopNav = () => {
	return (
		<ul
			className={`nav-menu-desktop pad d-flex flex-row justify-end h-full`}
			style={
				{
					// height: "812px",
					// visibility: showMobileNav ? "visible" : "hidden",
				}
			}
		>
			{navDetails?.map((detail) => {
				return <li key={detail.title}>{detail.title}</li>;
			})}
		</ul>
	);
};

const MobileNav = ({ showMobileNav, toggleMobileNav }) => {
	const bg = {
		hidden: { opacity: 0 },
		show: {
			opacity: 1,
			transition: {
				delayChildren: 0.5,
			},
		},
	};

	const { filterData, activeFilter, filterProjects, selectFilter } =
		useProjectsList();

	useEffect(() => {
		filterProjects();
	}, [activeFilter]);

	return (
		<div
			className={`nav-menu-mobile modal-display pad flex-col ${
				showMobileNav ? "show-menu" : "hide-menu"
			}`}
			style={{
				height: "812px",
				visibility: showMobileNav ? "visible" : "hidden",
			}}
		>
			<div className="menu-nav-mobile">
				<div className="nav__logo-wrap title-container">
					<div className="brand-title">
						<ScrollProgressIndicator />

						<a
							href="/"
							className="nav__logo menu-link-mobile"
							style={{
								transform: showMobileNav
									? "translateY(0px)"
									: "translateY(-140%)",
							}}
						>
							TheCopyDev
						</a>
					</div>
				</div>

				<div className="transition-wrap">
					<button
						className="close-btn mobile-menu-close"
						onClick={toggleMobileNav}
						style={{
							transform: showMobileNav
								? "translateY(0px)"
								: "translateY(-140%)",
						}}
					>
						CLOSE
					</button>
				</div>
			</div>

			<ul className="menu-links-mobile-wrap">
				<li className={`menu-link-wrap-mobile transition-wrap`}>
					<div className="count-wrap transition-wrap">
						<h4
							className="count"
							style={{
								transform: showMobileNav
									? "translateY(0px)"
									: "translateY(-100%)",
							}}
						>
							Sections
						</h4>
					</div>
				</li>
				<li className={`menu-link-wrap-mobile transition-wrap`}>
					{navDetails?.map((detail) => {
						return (
							<CLink
								type="nav"
								className="menu-link-mobile menu-links-inner "
								href={"/#contact-me"}
								onClick={() => {
									toggleMobileNav();
								}}
								style={{
									transform: showMobileNav
										? "translateY(0px)"
										: "translateY(-140%)",
								}}
								key={detail.title}
							>
								{detail.title}
							</CLink>
						);
					})}
				</li>

				<li className={`menu-link-wrap-mobile transition-wrap`}>
					<div className="count-wrap transition-wrap">
						<div
							className="count"
							style={{
								transform: showMobileNav
									? "translateY(0px)"
									: "translateY(-100%)",
							}}
						>
							Filter
						</div>
					</div>
				</li>
				{filterData.map((filter) => (
					<li
						key={filter}
						onClick={() => {
							selectFilter(filter);
							toggleMobileNav();
						}}
						className={`menu-link-wrap-mobile transition-wrap ${
							activeFilter.title === filter.title ? "active" : ""
						}`}
					>
						<button
							className="menu-link-mobile menu-links-inner"
							style={{
								transform: showMobileNav
									? "translateY(0px)"
									: "translateY(-140%)",
							}}
						>
							{filter.title}
						</button>

						<div className="count-wrap transition-wrap">
							<div
								className="count"
								style={{
									transform: showMobileNav
										? "translateY(0px)"
										: "translateY(-100%)",
								}}
							>
								{filter.count}
							</div>
						</div>
					</li>
				))}
			</ul>

			<div
				className="hsmallest split menu-tagline"
				// style={{ visibility: "hidden" }}
			>
				DRIVEN BY RESEARCH &amp; STRATEGY
				<br />
				DESIGNED TO ENGAGE
				<br />
				BUILT TO CONNECT
			</div>

			<motion.div
				className="nav-menu-mobile-bg"
				style={{
					transform: showMobileNav
						? "translateY(0px)"
						: "translateY(-100%)",
				}}
			></motion.div>
		</div>
	);
};
